import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 14,
	viewBox: "0 0 15 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 6.89286L6.10714 12L13.9643 1",
		stroke: "#222222",
		strokeWidth: 2
	})
});
export default SvgCheckmark;
